// extracted by mini-css-extract-plugin
export default {"parent":"styles_parent__CcZoY","customBox":"styles_customBox__WZDR6","contentBox":"styles_contentBox__Aba0L","headingBox":"styles_headingBox__MjhGs"};